import FilePresenter from '../presenters/FilePresenter';

const _fetchMetadata = (r) => {
  const headerVal = r.headers.get('upload-metadata');
  const obj = {};

  if (headerVal && headerVal.length) {
    headerVal.split(',').forEach((kv) => {
      const [key, value] = kv.split(' ');
      obj[key] = Buffer.from(value, 'base64').toString();
    });
    return obj;
  }
  // Not expecting this to happen but want a clear understanding of the problem if does occur
  throw new Error(`HEAD ${r.url} failed to return header upload-metadata`);
};

const _tusFetchUrlPromise = (tusConfig, url) => fetch(url, {
  method: 'HEAD',
  headers: tusConfig.headers,
});

const UploadCompleteHandler = (tusConfig, onComplete, onSuccess, onError) => (
  async ({
    successful: successfulUppyFiles = [],
    failed: failedUppyFiles = [],
  }) => {
    const failedFilePresenters = failedUppyFiles.map((uppyFile) => new FilePresenter({ uppyFile, isSuccessful: false }));

    const promises = [];
    const successfulFilePresenters = [];

    successfulUppyFiles.forEach((uppyFile) => {
      // The tus-js-client is restrictive on what header data it exposes to the user
      // We need to be able to fetch the custom metadata response header to capture information like s3 key/bucket
      // The HEAD endpoint is used sort of as a status of the upload, we can leverage this endpoint to retrieve
      // any meta data content we want to configure.

      // Future considerations:
      //  We may eventually want to leverage a kj-tus GET requestfor this

      //  tus 2.0 protocol will allow for passing custom metadata headers
      //  so this additional request may eventually be unecessary entirely
      promises.push(_tusFetchUrlPromise(tusConfig, uppyFile.uploadURL));
      successfulFilePresenters.push(new FilePresenter({ uppyFile, isSuccessful: true }));
    });

    onComplete([...failedFilePresenters, ...successfulFilePresenters]);

    await Promise.all(promises).then((responses) => {
      responses.forEach((_response) => {
        const filePresenter = successfulFilePresenters.find((_fp) => _fp.url() === _response.url);
        const meta = _fetchMetadata(_response);
        filePresenter.update({ meta });
      });
    });

    if (failedFilePresenters.length) {
      onError(failedFilePresenters);
    } else {
      onSuccess(successfulFilePresenters);
    }
  }
);

export default UploadCompleteHandler;
